.texto {
  padding: var(--s-6) var(--s-7);
  border-radius: var(--r-card);
  background: var(--surface-sunken);
  border: var(--bw-hair) solid var(--border-hair);
  font-size: var(--fs-xs);
  line-height: 20px;
  color: var(--gray-700);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.variable {
  background: var(--surface-brand-soft);
  color: var(--accent-700);
  border-radius: var(--r-xs);
  padding: 0 3px;
  font-weight: var(--fw-semibold);
}
